<template>
  <div>
    <v-form
      ref="form"
      class="mx-2"
      lazy-validation
    >
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            ref="firstName"
            v-model="localData.firstName"
            label="نام*"
            :error-messages="errorMessages"
            :rules="[() => !!localData.firstName || 'نام را وارد کنید']"
            required
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            ref="lastName"
            v-model="localData.lastName"
            label="نام خانوادگی*"
            :error-messages="errorMessages"
            :rules="[() => !!localData.lastName || 'نام خانوادگی را وارد کنید']"
            required
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            ref="username"
            v-model="localData.userName"
            label="نام کاربری*"
            :error-messages="errorMessages"
            :rules="[() => !!localData.userName || 'نام کاربری را وارد کنید']"
            required
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            ref="email"
            v-model="localData.email"
            label="ایمیل*"
            :error-messages="errorMessages"
            :rules="[() => !!localData.email || 'ایمیل را وارد کنید']"
            required
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="localData.password"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[() => !!localData.password || 'کلمه عبور را وارد کنید']"
            :error-messages="errorMessages"
            :type="show1 ? 'text' : 'password'"
            name="password"
            label="کلمه عبور*"
            hint="حداقل 8 کاراکتر"
            @click:append="show1 = !show1"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="localData.confirmPassword"
            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[() => localData.confirmPassword === localData.password || 'تکرار کلمه عبور با کلمه عبور مطابقت ندارد']"
            :error-messages="errorMessages"
            :type="show2 ? 'text' : 'password'"
            name="confirmPassword"
            label="تکرار کلمه عبور*"
            @click:append="show2 = !show2"
          />
        </v-col>
      </v-row>
      <small>*فیلدهای ستاره دار ضروری هستند.</small>
    </v-form>
    <v-card-actions>
      <v-spacer />
      <v-btn
        @click="$emit('callbck',false)"
      >
        بستن
      </v-btn>
      <v-btn
        color="blue"
        dark
        @click="submit()"
      >
        ذخیره
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
  import api from '@/util/app-api'
  import toast from '@/util/toast'

  export default {
    name: 'ModifyUserView',
    components: {
    },
    props: {
      data: { type: Object },
    },
    data () {
      return {
        errorMessages: '',
        localData: {},
        show1: false,
        show2: false,
      }
    },
    mounted () {
      this.prepareData()
    },
    methods: {
      submit () {
        if (!this.$refs.form.validate()) { return }

        api.post('admin/user/' + (this.localData.id === 0 ? 'create' : 'edit'), this.localData)
          .then(
            response => {
              toast.success('اطلاعات با موفقیت ذخیره شد.')
              this.$emit('callbck', true)
            })
          .catch(err => {
            toast.error(err.message)
          })
      },
      prepareData () {
        if (!this.data) {
          this.data = { id: 0 }
        }
        if (!this.data.id) {
          this.data.id = 0
        }
        api.get('admin/user/get/' + this.data.id, null)
          .then(
            response => {
              this.localData = response
              if (this.data.id === 0) Object.assign(this.localData, this.data)
            })
          .catch(err => {
            toast.error(err.message)
          })
      },
    },
  }
</script>
<style>
</style>
